import { convertUnitsToPixels } from '../../assets/js/helpers/convert-units-to-pixels';
import { getInlineSize } from '../../assets/js/helpers/get-inline-size';

// TODO: Write unit test

export default function getPageDimensions (pageSVG, widthOverride, heightOverride, DPI = 300) {
  const { width, height, unit } = getInlineSize(pageSVG);

  const sourceWidth = Number(pageSVG.getAttribute('width'));
  const sourceHeight = Number(pageSVG.getAttribute('height'));
  let destinationWidth = widthOverride || convertUnitsToPixels(width, unit, 1, DPI) || sourceWidth;
  let destinationHeight = heightOverride || convertUnitsToPixels(height, unit, 1, DPI) || sourceHeight;
  const aspectRatio = Math.min(destinationWidth / sourceWidth, destinationHeight / sourceHeight);
  destinationWidth = Math.floor(sourceWidth * aspectRatio);
  destinationHeight = Math.floor(sourceHeight * aspectRatio);

  return { sourceWidth, sourceHeight, destinationWidth, destinationHeight };
}
